import {WarmupData} from '@wix/music-server/types';
import {MusicAlbumCollection} from '@wix/music-shared/typings/music-collection';
import {injectable, decorate} from 'inversify';
import {IGlobal, MetaData, WidgetData} from './IGlobal';

export class Global implements IGlobal {
  private readonly warmupData: WarmupData | undefined;

  constructor() {
    this.warmupData = (window as any).warmupData;
  }

  getPreLoadedCollection(): MusicAlbumCollection | undefined {
    return this.warmupData?.collection;
  }

  getWidgetData(): WidgetData | undefined {
    const widgetData = this.getMetaData()?.widgetData;

    if (widgetData) {
      return {
        ...widgetData,
        style: {
          colors: {},
          fonts: {},
          numbers: {},
          booleans: {},
          googleFontsCssUrl: '',
          uploadFontFaces: '',
          ...widgetData.style,
        },
      };
    }
  }

  private getMetaData(): MetaData | undefined {
    return this.warmupData?.metaData;
  }
}

decorate(injectable(), Global);
